var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.loading},[_c('el-progress',{attrs:{"type":"circle","color":"#6360E6","percentage":_vm.progress,"show-text":false,"stroke-width":4,"width":40}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }